/* eslint-disable @typescript-eslint/naming-convention */
import { useParams } from 'react-router-dom'
import { useSignal } from "@preact/signals-react"

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import logo from '../assets/shift4.png'

import HeaderLink from './HeaderLink.jsx'
import LoadingAnimation from './LoadingAnimation'
import UserBox from './UserBox'

import { userPermissionsSummarySignal } from '../state/signals/permissionSignals.js'

export default function Header() {

    const { beId } = useParams()

    return (
        <Navbar variant='dark' expand="lg" bg='dark' className="justify-content-between px-3 py-1">
            <Container fluid>
                <Navbar.Brand href="/">
                    <img src={logo} height="40" className="d-inline-block align-top" alt="Shift4 Command Center" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav>
                        <HeaderLink eventkey="dashboard" to={`/be/${beId}/dashboard`}>Dashboard</HeaderLink>
                        {
                            userPermissionsSummarySignal.value ? (
                                <>
                                    {
                                        userPermissionsSummarySignal.value.canViewUtgs && <HeaderLink eventkey="utgs" to={`/be/${beId}/utgs`}>UTGs</HeaderLink>
                                    }
                                    {
                                        userPermissionsSummarySignal.value.canViewUtgs && <HeaderLink eventkey="templates" to={`/be/${beId}/templates`}>Config Templates</HeaderLink>
                                    }
                                    {
                                        userPermissionsSummarySignal.value.canViewTasks && <HeaderLink eventkey="tasks" to={`/be/${beId}/tasks`}>Tasks</HeaderLink>
                                    }
                                    {
                                        userPermissionsSummarySignal.value.canViewDevices && <HeaderLink eventkey="devices" to={`/be/${beId}/devices`}>Devices</HeaderLink>
                                    }
                                    {
                                        userPermissionsSummarySignal.value.canViewForms && <HeaderLink eventkey="forms" to={`/be/${beId}/forms`}>Forms</HeaderLink>
                                    }
                                    {
                                        userPermissionsSummarySignal.value.canViewProfiles && <HeaderLink eventkey="profiles" to={`/be/${beId}/profiles`}>Profiles</HeaderLink>
                                    }
                                    {
                                        userPermissionsSummarySignal.value.canViewInstallations && <HeaderLink eventkey="installations" to={`/be/${beId}/installations`}>Installations</HeaderLink>
                                    }
                                    {
                                        userPermissionsSummarySignal.value.canViewAccounts && <HeaderLink eventkey="management" to={`/be/${beId}/management/accounts`}>Accounts</HeaderLink>
                                    }
                                </>
                            ) : (<LoadingAnimation />)
                        }
                    </Nav>
                </Navbar.Collapse>
                <UserBox />
            </Container>
        </Navbar>
    )
}